import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import Utils from '../../utils';
import QueryParamProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '../../screens';
import audio from '../../utils/audio';
import CdnPath from '../../utils/cdnPath';
var TOOLTIP_STATES = {
  REWARD: 'reward',
  GAME_UNLOCK: 'gameUnlock',
  EMPTY: ''
};
var TOOLTIP_ANIMATION_STATES = {
  IN: 'in',
  OUT: 'out'
};

var LevelUp = /*#__PURE__*/function (_Component) {
  _inherits(LevelUp, _Component);

  var _super = _createSuper(LevelUp);

  function LevelUp(props) {
    var _this;

    _classCallCheck(this, LevelUp);

    _this = _super.call(this, props);

    _this.checkFontSizeBasedOnLength = function (text) {
      var textLen = text.length;

      if (textLen < 20) {
        return {
          nameFontSize: _this.props.RFValue(14),
          boxWidth: _this.props.RFValue(240)
        };
      } else if (textLen < 25) {
        return {
          nameFontSize: _this.props.RFValue(11),
          boxWidth: _this.props.RFValue(270)
        };
      } else {
        return {
          nameFontSize: _this.props.RFValue(10),
          boxWidth: _this.props.RFValue(280)
        };
      }
    };

    _this.showGameUnlockTooltip = function () {
      var gameUnlock = _this.props.gameUnlock;
      var imageSource = {
        uri: "".concat(CdnPath.SLOT_ICON_MOBILE).concat(gameUnlock.GAME_ID, ".png")
      };
      var _tooltipDetails = {
        animationState: TOOLTIP_ANIMATION_STATES.IN,
        clickAbleTooltip: true,
        disableChildren: true,
        title: 'NEW GAME UNLOCKED',
        subTitle: !!gameUnlock && !!gameUnlock.GAME_NAME && gameUnlock.GAME_NAME.toUpperCase() || '-',
        source: imageSource,
        ibw: _this.props.ibw,
        gameImageStyle: _this.props.gameImageStyle,
        iconType: _this.props.iconType ? _this.props.iconType : {},
        containerStyle: {
          width: _this.checkFontSizeBasedOnLength(gameUnlock ? gameUnlock.GAME_NAME : '-').boxWidth,
          height: _this.props.RFValue(65)
        },
        titleStyle: _this.props.titleStyle,
        subTitleStyle: {
          fontSize: _this.checkFontSizeBasedOnLength(gameUnlock ? gameUnlock.GAME_NAME : '-').nameFontSize,
          fontWeight: '700'
        },
        tipStyle: _objectSpread({}, _this.props.tipStyle ? _this.props.tipStyle : {}),
        actionHandler: _this.launchGame
      };

      _this.props.tooltipDetails(_tooltipDetails);

      _this.props.shouldShowTooltip(true);

      setTimeout(function () {
        _this.props.tooltipDetails(_objectSpread(_objectSpread({}, _tooltipDetails), {}, {
          animationState: TOOLTIP_ANIMATION_STATES.OUT
        }));
      }, 6000);
    };

    _this.launchGame = function () {
      audio.onClick();
      QueryParamProxy.navigate(_this.props.navigation, Screens.Game, _defineProperty({}, RouteParamConstants.PARAM_GAME_ID, _this.props.gameUnlock.GAME_ID));

      _this.props.setGameId(_this.props.gameUnlock.GAME_ID);

      _this.props.shouldShowTooltip(false);
    };

    _this.state = {
      tooltip: TOOLTIP_STATES.REWARD,
      animation: TOOLTIP_ANIMATION_STATES.IN
    };
    return _this;
  }

  _createClass(LevelUp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var nextTooltipState = this.props.gameUnlock ? TOOLTIP_STATES.GAME_UNLOCK : TOOLTIP_STATES.EMPTY;
      window.setTimeout(function () {
        _this2.setState({
          animation: TOOLTIP_ANIMATION_STATES.OUT
        }, function () {
          window.setTimeout(function () {
            _this2.setState({
              tooltip: nextTooltipState,
              animation: TOOLTIP_ANIMATION_STATES.IN
            }, function () {
              if (nextTooltipState === TOOLTIP_STATES.GAME_UNLOCK) {
                if (_this2.props.gameUnlock && Utils.getPlatform() != 'web') {
                  _this2.showGameUnlockTooltip();
                }

                audio.playSfx('lockOpen', true, 1);
                window.setTimeout(function () {
                  _this2.setState({
                    animation: TOOLTIP_ANIMATION_STATES.OUT
                  }, function () {
                    window.setTimeout(function () {
                      _this2.setState({
                        tooltip: TOOLTIP_STATES.EMPTY,
                        animation: TOOLTIP_ANIMATION_STATES.IN
                      });
                    }, 600);
                  });
                }, 6000);
              }
            });
          }, 600);
        });
      }, 3000);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          coins = _this$props.coins,
          maxBet = _this$props.maxBet,
          gameUnlock = _this$props.gameUnlock;
      return this.props.render({
        coins: Utils.truncateFormat(coins),
        maxBet: Utils.truncateFormat(maxBet),
        tooltip: this.state.tooltip,
        animation: this.state.animation,
        gameUnlock: gameUnlock,
        launchGame: this.launchGame
      });
    }
  }]);

  return LevelUp;
}(Component);

export { LevelUp as default };
LevelUp.TOOLTIP_STATES = TOOLTIP_STATES;
LevelUp.TOOLTIP_ANIMATION_STATES = TOOLTIP_ANIMATION_STATES;